module.exports = __webpack_public_path__ + "img/home-restaurant-02.a61d41f5.jpg";